import { SearchFiltersType, SearchItemType } from './nausearchType';

export enum SavedSearchViewingModeEnum {
  all = 'ALL',
  bookmarked = 'BOOKMARKED',
}

export enum SavedSearchViewingOrderEnum {
  updateDate = 'UPDATE_DATE',
  newCount = 'NEW_COUNT',
}

export type SavedSearchStoreType = {
  error: boolean;
  errorText: string;
  hasMore: boolean;
  loading: boolean;
  redirect?: boolean;
  directories: SavedSearchDirectoryType[];
  savedSearchItem?: SavedSearchItemType;
  savedSearchResults?: SavedSearchResultType[];
  savedSearchList: SavedSearchItemType[];
  savedSearchRecentList: SavedSearchItemType[];
  savedSearchHistory: SavedSearchItemType[];
  savedSearchListPage: number;
  currentDirectory?: SavedSearchDirectoryType;
};

export type SavedSearchResultType = {
  current: boolean;
  id: string;
  ed: string;
  ord: number;
  rObject: string;
  rSavedSearch: string; // id запроса
  response: SearchItemType;
};

export type SavedSearchRequestType = {
  page?: number;
  pageSize?: number;
  mode?: string;
  order?: string;
  directoryId?: string;
};

export type SavedSearchRequestSuccessType = { data: SavedSearchItemType[]; page?: number };

export type SavedSearchDirectoryType = {
  id: string;
  name: string;
  getrUser: string;
  objectCount: number | null;
  pinned: boolean;
};

export type SavedSearchItemType = {
  id: string;
  sd: string;
  ed: string;
  rUser: string;
  name: string;
  request: SearchFiltersType & { message: string };
  cResource?: string;
  cLang?: string;
  resultCnt: number;
  cSearchPeriod: string; // Периодичность обновления результатов поиска, #181. Выбор значения 181:100 отключает автоматическое обновление и дальнейшее обновление возможно только вручную
  cNotificationMethods: string[]; // Массив со списком способов уведомления о новых результатах
  cNotificationContent?: string; // Содержание уведомления (для email)
  newResultCount: number;
  bookmarked: boolean; // Признак, является ли поиск сохраненным. Для несохраненного поиска не хранится список результатов и прочие атрибуты. Запрос (request) хранится всегда
  notify: boolean; // Уберется
  directoryId: string | null;
  directoryName: string | null;
  udt: string;
};

export type SavedSearchCreateType = {
  id?: string;
  rUser: string | null;
  name: string;
  cResource?: string;
  cSearchPeriod: string;
  bookmarked?: boolean;
  directoryId?: string;
  request?: SearchFiltersType & { message: string };
};

export type SavedSearchMoveType = {
  id: string;
  toDir?: string; // ID директории, в которую переносят сохраненный поиск. Если параметр пустой - вынести поиск из директории
};

export type SavedSearchDirectoryGetType = {
  page?: number;
  pageSize?: number;
};

export type SavedSearchDirectoryResultType = {
  directories: SavedSearchDirectoryType[];
  hasMore: boolean;
};
